<template>
  <div>
    <q-form ref="editForm">
      <c-card title="상위공정 상세" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline >
            <c-btn v-if="editable" label="신규 공정" icon="add" @btnClicked="addParent" />
            <c-btn
              v-if="editable"
              :disabled="!saveable"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="data"
              :mappingType="saveType"
              label="저장"
              icon="save"
              @beforeAction="saveData"
              @btnCallback="saveCallback" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-3">
            <c-text
              :editable="editable && dataeditable"
              :required="true"
              label="상위공정명"
              name="processName"
              v-model="data.processName">
            </c-text>
          </div>
          <div class="col-3">
            <c-text
              :editable="editable && dataeditable"
              label="상위공정 관리번호"
              name="processNo"
              v-model="data.processNo">
            </c-text>
          </div>
          <div class="col-2">
            <c-plant
              :required="true"
              :editable="editable && dataeditable"
              label="사업장"
              name="plantCd"
              v-model="data.plantCd">
            </c-plant>
          </div>
          <div class="col-2">
            <c-text
              :editable="editable && dataeditable"
              :required="true"
              label="정렬순서"
              type="number"
              name="orderNo"
              v-model="data.orderNo">
            </c-text>
          </div>
          <!-- <div class="col-4">
            <c-checkbox
              :editable="editable && dataeditable"
              :isFlag="true"
              label="PSM대상"
              name="psmFlag"
              v-model="data.psmFlag"
            />
          </div> -->
          <div class="col-2">
            <c-checkbox
              :editable="editable && dataeditable"
              :isFlag="true"
              label="사용여부"
              name="useFlag"
              v-model="data.useFlag"
            />
          </div>
          <div class="col-3">
            <c-text
              :editable="editable && dataeditable"
              label="주재료"
              name="mainMaterial"
              v-model="data.mainMaterial">
            </c-text>
          </div>
          <div class="col-3">
            <c-text
              :editable="editable && dataeditable"
              label="생산품"
              name="productName"
              v-model="data.productName">
            </c-text>
          </div>
          <div class="col-2">
            <c-text
              :editable="editable && dataeditable"
              label="근로자수"
              name="workerCnt"
              suffix="명"
              type="number"
              v-model="data.workerCnt">
            </c-text>
          </div>
          <div class="col-4">
            <c-text
              :editable="editable && dataeditable"
              label="상위공정설명"
              name="processDesc"
              v-model="data.processDesc">
            </c-text>
          </div>
          <div class="col-12">
            <c-upload
              :attachInfo="attachInfoUp"
              :editable="editable && attachable && dataeditable"
              label="상위공정 사진">
            </c-upload>
          </div>
          <div class="col-12">
            <c-upload
              :attachInfo="attachInfo3"
              :editable="editable && attachable && dataeditable"
              label="그 밖의 유해위험정보">
            </c-upload>
          </div>
        </template>
      </c-card>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'process-detail',
  props: {
    param: {
      type: Object,
      default: () => ({
        plantCd: null,
        useFlag: '',
      }),
    },
    parentProcessCd: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      attachable: false,
      attachInfoUp: {
        isSubmit: '',
        taskClassCd: 'PROCESS_UP',
        taskKey: '',
      },
      attachInfo3: {
        isSubmit: '',
        taskClassCd: 'PROCESS_UNIT_HAZARD',
        taskKey: '',
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      psmYnItems: [
        { code: 'Y', codeName: '대상' },
        { code: 'N', codeName: '해당없음' },
      ],
      data: {
        plantCd: null,
        processCd: '',
        processNo: '',
        processName: '',
        upProcessCd: '',
        processLevelCd: '',
        processDesc: '',
        managementDepts: '',
        orderNo: '',
        mainMaterial: '',
        workerCnt: '',
        productName: '',
        useFlag: 'Y',
        psmFlag: 'Y',
      },
      listUrl: '',
      detailUrl: '',
      checkUrl: '',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      saveable: false,
      deleteable: false,
      editable: true,
      dataeditable: false,
      updateMode: false,
      isSave: false,
      saveUrl: transactionConfig.mdm.process.insert.url,
      saveType: 'POST',
      searchUrl: '',
      selectedProcessCd: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  watch: {
    parentProcessCd() {
      if (this.parentProcessCd) {
        this.rowClick({ processCd: this.parentProcessCd })
      } else {
        this.reset();
      }
    },
    'param.plantCd'() {
      this.reset();
    },
    'param.useFlag'() {
      this.reset();
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.dataeditable = false;
      // api scope
      this.detailUrl = selectConfig.mdm.process.get.url;
      this.checkUrl = selectConfig.mdm.process.check.url;
      this.insertUrl = transactionConfig.mdm.process.insert.url;
      this.updateUrl = transactionConfig.mdm.process.update.url;
      this.deleteUrl = transactionConfig.mdm.process.delete.url;
    },
    rowClick(row) {
      // 상세조회
      this.saveable = true;
      this.deleteable = true;
      this.rowNotSelected = false;
      this.updateMode = true;
      this.selectedProcessCd = row.processCd;
      if (row.processLevelCd == '10') {
        this.lvl1Check = true;
      } else {
        this.lvl1Check = false;
      }
      this.$http.url = this.$format(this.detailUrl, this.selectedProcessCd);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data = _result.data;
        this.attachable = true;
        this.$set(this.attachInfoUp, 'taskKey', _result.data.processCd)
        this.$set(this.attachInfo3, 'taskKey', _result.data.processCd);
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
        this.dataeditable = true;
      },
      () => {
      });
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName('bg-light-blue-1')[1];
      if (_table) {
        _table.classList.remove('bg-light-blue-1');
      }
    },
    addParent() {
      this.rowRemoveSelect();
      this.attachable = true;
      this.saveable = true;
      this.deleteable = false;
      this.saveUrl = this.insertUrl;
      this.saveType = 'POST';
      this.updateMode = false;
      this.dataeditable = true;
      this.data = {
        plantCd: this.param.plantCd ? this.param.plantCd : null,
        processCd: '',
        processNo: '',
        processName: '',
        upProcessCd: '',
        processLevelCd: '10',
        processDesc: '',
        managementDepts: '',
        orderNo: '',
        useFlag: 'Y',
        psmFlag: 'Y',
      };
      // this.$emit('isNew');
      this.$set(this.attachInfoUp, 'taskKey', '')
      this.$set(this.attachInfo3, 'taskKey', '');
    },
    reset() {
      this.saveable = false;
      this.deleteable = false;
      this.updateMode = false;
      this.attachable = false;
      this.dataeditable = false;
      this.data = {
        plantCd: null,
        processCd: '',
        processNo: '',
        processName: '',
        upProcessCd: '',
        processLevelCd: '',
        processDesc: '',
        managementDepts: '',
        orderNo: '',
        useFlag: 'Y',
        psmFlag: 'Y',
      };
      this.$set(this.attachInfoUp, 'taskKey', '');
      this.$set(this.attachInfo3, 'taskKey', '');
      this.$emit('isNew');
    },
    saveData() {
      this.$refs['editForm'].validate().then(_result => {
        // 중복체크
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId
              this.data.chgUserId = this.$store.getters.user.userId
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    deleteData() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.data.processCd);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isSave = !this.isSave;
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.saveType == 'POST') {
        this.$set(this.attachInfoUp, 'taskKey', _result.data)
        this.$set(this.attachInfo3, 'taskKey', _result.data);
        this.$set(this.attachInfoUp, 'isSubmit', uid())
        this.$set(this.attachInfo3, 'isSubmit', uid())
        // this.reset();
        this.selectedProcessCd = '';
      }
      this.rowClick({processCd: _result.data});
      this.$emit('searchDetail', _result.data);
    },
  }
};
</script>
